import { useSelector } from "react-redux";

const BajajExcelUpload = () => {
  return (
    <>
      {/* <h4 style={{ "text-align": "center", "padding-bottom": "20px" }}>Purchase Reports</h4> */}
      <div className="iframe-div">
        <iframe
          title="Report Section"
          width="600"
          height="373.5"
          src="https://iipl.retool.com/embedded/public/290ac362-ade5-42f5-a082-40008d1b0a44"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </div>
    </>
  );
};

export default BajajExcelUpload;
